import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import DownLoadIcon from "../../../asset/images/downloadicon.svg";
import { Modal } from "react-bootstrap";
import { Constants } from "../../../CommonMethhods/Constants";
import UploadIcon from "../../../asset/images/uploadInconimg.svg";
import * as XLSX from "xlsx";
import {
  decryptData,
  encryptData,
  getInvoiceId,
  splitDate,
} from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import Loader from "../../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import LoaderForSearch from "../../../Components/Common/LoaderForSearch";
import {
  partner_Admin,
  partner_Admin_Url,
} from "../../../Configuration/Partner_URL";
import { useDebounce } from "../../../Components/useDebounce";
import { axiosSsoFormData, axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";

function Invoice() {
  let navigate = useNavigate();
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(false);
  const [searchBar, setSearchBar] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [customDate, setCustomDate] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dayWiseDate, setDayWiseDate] = useState("today");
  const [page, setPage] = useState(1);
  const [partnerInvoice, setPartnerInvoice] = useState([]);
  const [fileExtension, setFileExtension] = useState();
  const [totalCount, setTotalCount] = useState();
  const [scrollLoader, setScrollLoader] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [fileVal, setFileVal] = useState();
  const [radioChanges, setRadioChanges] = useState("Upload Commission");

  if (storeToken == null) {
    window.location.replace("/");
  }

  const debouncedValue = useDebounce(name, 1000);
  useEffect(() => {
    handleSearchName(1, debouncedValue);
  }, [debouncedValue]);

  const handleSearchName = () => {
    getPartnerInvoices(1, dayWiseDate);
    if (name?.length > 0) {
      setLoader(false);
    }
    setScrollLoader(false);
  };

  const getPartnerInvoices = async (pageNo = 1, dayWise) => {
    if (page === 1) {
      setLoader(true);
    }
    try {
      const getOnboardingDetails = await axiosSsoText.get(
        `${partner_Admin.Get_Partner_Invoices_Url
        }?page=${pageNo}&limit=${10}&range=${dayWise}&from=${fromDate}&to=${toDate}&search=${name}`,
      );
      const res = decryptData(getOnboardingDetails?.data);
      let decryptedRes = JSON.parse(res);


      if (decryptedRes?.status === 0) {
        setError(false);
        setTotalCount(decryptedRes?.data?.info?.count);
        if (pageNo > 1) {
          setPartnerInvoice((prev) => {
            return [...prev, ...decryptedRes?.data?.info?.partners];
          });
        } else {
          setPartnerInvoice(decryptedRes?.data?.info?.partners);
        }
      } else {
        setPartnerInvoice([]);
        toast.error(decryptedRes?.data?.message);
        setError(decryptedRes?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  useEffect(() => {
    if (page > 1) {
      getPartnerInvoices(page, dayWiseDate);
    }
  }, [page]);

  const callAPI1 = async () => {
    let payloadReq = {
      file: fileExtension,
      userId: localStorage.getItem("userId"),
    };
    console.log(payloadReq, "payloadReq");
    let payloadApproved = encryptData(JSON.stringify(payloadReq));
    console.log(payloadApproved, "payloadApproved");
    try {
      const getCommission = await axiosSsoText.post(
        `${partner_Admin.GET_COMMISSION_URL}`,
        payloadApproved,
      );
      const getData = decryptData(getCommission?.data);
      let decryptedData = JSON.parse(getData);
      if (decryptedData?.status === 0) {
        toast.success(decryptedData?.data?.message);
      } else {
        toast.error(decryptedData?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callAPI2 = async () => {
    let payloadReq = {
      file: fileExtension,
      userId: localStorage.getItem("userId"),
    };
    let payloadApproved = encryptData(JSON.stringify(payloadReq));
    try {
      const getApproved = await axiosSsoText.post(
        `${partner_Admin.GET_APPROVED_LIST}`,
        payloadApproved,
      );
      const getResp = decryptData(getApproved?.data);
      let decryptedResp = JSON.parse(getResp);
      if (decryptedResp?.status === 0) {
        toast.success(decryptedResp?.data?.message);
      } else {
        toast.error(decryptedResp?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // for excel sheet read start
  const handleFileChange = (e) => {
    const file = e.target?.files[0];
    const reader = new FileReader();
    console.log(file?.name, "file");
    setFileVal(e.target?.files[0])

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      console.log(data, "data");
      const workbook = XLSX.read(data, {
        type: "array",
        cellDates: true,
        dateNF: "dd-mm-yyyy",
      });
      console.log(workbook, "workbook");
      const sheetName = workbook.SheetNames[0];
      console.log(sheetName, "sheetName");
      const sheet = workbook.Sheets[sheetName];
      console.log(sheet, "sheet");

      // Convert sheet data to JSON format
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      console.log(jsonData, "jsonData");

      // Format the dates in the JSON data
      const formattedData = jsonData.map(row => {
        // Assuming the date column is named "InvoiceDate"
        if (row.InvoiceDate) {
          const date = new Date(row.InvoiceDate);
          // Format the date as needed, e.g., "dd-mm-yyyy"
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
          const year = date.getFullYear();
          row.InvoiceDate = `${day}-${month}-${year}`;
        }
        return row;
      });

      console.log(formattedData, "formattedData");
      setFileExtension(formattedData);
    };
    reader.readAsArrayBuffer(file);
  };


  const getRadioValue = (e) => {
    document.querySelector("#uploadFile").value = "";
    setRadioChanges(e.target.value);
  };
  const submitButtonAPI = () => {
    if (radioChanges === "Upload Commission" && fileVal?.name?.length > 0) {
      callAPI1();
    } else if (radioChanges === "Upload Approved List" && fileVal?.name?.length > 0) {
      callAPI2();
    }
  };
  // for excel sheet read end

  const handleOnChange = (e) => {
    setPage(1);
    if (e?.target?.value !== "custom-range") {
      setDayWiseDate(e?.target?.value);
      getPartnerInvoices(1, e?.target?.value);
    } else {
      setDayWiseDate("");
      setCustomDate(true);
    }
  };

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (totalCount) {
        if (!(totalCount <= 10 * page)) {
          setPage((prev) => prev + 1);
          setScrollLoader(true);
        }
      }
      if (name?.length > 0) {
        setScrollLoader(false);
      }
    }
  };

  const searchHandle = useMemo(() => {
    if (searchBar === "") {
      return partnerInvoice;
    } else if (partnerInvoice && partnerInvoice?.length > 0) {
      return partnerInvoice?.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchBar.toLowerCase())
        )
      );
    }
  }, [searchBar, partnerInvoice]);

  const ascendingOrder = () => {
    let ascendingItems = partnerInvoice.sort((a, b) => a.Id - b.Id);
    setPartnerInvoice([...ascendingItems]);
  };

  const descendingOrder = () => {
    let descendingItems = partnerInvoice.sort((a, b) => {
      return b.Id - a.Id;
    });
    setPartnerInvoice([...descendingItems]);
  };

  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            getPartnerInvoices(1, dayWiseDate);
            setCustomDate(false);
            setFromDate("");
            setToDate("");
          }}
        >
          Button
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Button
        </button>
      );
    }
  }

  // const downloadFile = async (url) => {
  //   const response = await axios.get(url, {
  //     headers: {
  //       // "Content-Type": "text/plain",
  //       Authorization: `Bearer ${storeToken}`,
  //     },
  //   });
  //   const headers = response.headers;
  //   if (headers["content-type"] !== "text/csv") {
  //     toast.error("No Data Found");
  //     return;
  //   }
  //   const binary = [];
  //   binary.push(response.data);

  //   const href = window.URL.createObjectURL(
  //     new Blob(binary, { type: "text/csv" })
  //   );
  //   const link = document.createElement("a");
  //   link.href = href;
  //   link.setAttribute("download", "lead.csv");
  //   document.body.appendChild(link);
  //   link.click();

  //   document.body.removeChild(link);
  //   window.URL.revokeObjectURL(href);
  // };

  const downloadFile = async (url) => {
    const response = await axiosSsoFormData.get(url);

    const headers = response.headers;
    if (headers["content-type"] !== "text/csv") {
      toast.error("No Data Found");
      return;
    }

    const binary = [];
    binary.push(response.data);

    // ✅ Format today's date as YYYY_MM_DD
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}_${mm}_${dd}`;

    // ✅ Dynamic filename
    const filename = `PARTNER_INVOICE_${formattedDate}.csv`;

    const href = window.URL.createObjectURL(
      new Blob(binary, { type: "text/csv" })
    );
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(href);
  };
  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending">
        <div className="card-box invoice-wrapper">
          <div className="card-title">
            <div class="search-box">
              <div class="form-group">
                <div class="for-position oms-search partner-search">
                  <input
                    type="text"
                    class="input-st"
                    placeholder="Search here..."
                    autocomplete="off"
                    id="invoice-bar"
                    onChange={(e) => {
                      setName(e?.target?.value);
                      setPage(1);
                    }}
                    onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;

                    let input = e.target.value.toUpperCase();
                    input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                            input = input.replace(/\s{2,}/g, " "); 
                            input = input.replace(/^\s+/, ""); 

                    if (input.length > 100) input = input.slice(0, 100);
                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                  }}
                  />
                  {/* <span
                    className="icon-search-bar"
                  // onClick={(e) => handleSearch(e)}
                  /> */}
                </div>
              </div>
            </div>
            <div className="upload-wrapper admin-btn">
              <div
                onClick={() =>
                  downloadFile(
                    `${partner_Admin_Url}/admin/partnerInvoices/csv?page=1&limit=10&range=${dayWiseDate}&sort-by=id&sort-order=asc`
                  )
                }
                className={
                  searchHandle && searchHandle.length > 0 ? "" : "disabled-link"
                }
              >
                <img src={DownLoadIcon} alt="download" className="down-icon" />
              </div>
              <img
                src={UploadIcon}
                alt="upload"
                className="down-icon cursor-pointer "
                onClick={() => setShowModal(true)}
              />
              <select onChange={(e) => handleOnChange(e)}>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this-month">This Month</option>
                <option value="this-week">This Week</option>
                <option value="last-week">Last Week</option>
                <option value="last-month">Last Month</option>
                <option value="till-date">Till Date</option>
                <option value="custom-range">Custom Range</option>
              </select>
            </div>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : searchHandle && searchHandle?.length > 0 ? (
            <div className="table-wrapper scroll-table">
              <table className="table partner-table">
                <thead>
                  <tr>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Sr No</span>
                        {/* <span>
                        <span className="icon-up-triangle" onClick={() => ascendingOrder()}></span>
                        <span className="icon-down-triangle" onClick={() => descendingOrder()}></span>
                      </span> */}
                      </span>
                    </th>
                    <th scope="col" className="">
                      <span className="invoice-th">
                        <span>Name</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Invoice Number </span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>SAP Code</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Partner Code</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Amount</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Invoice Date</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th scope="col">
                      <span className="invoice-th">
                        <span>Status</span>
                        <span>
                          <span
                            className="icon-up-triangle"
                            onClick={() => ascendingOrder()}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => descendingOrder()}
                          ></span>
                        </span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody onScroll={(e) => handleScroll(e)}>
                  {searchHandle &&
                    searchHandle.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{item?.Name || "-"}</td>
                          <td>{item?.InvoiceNo || "-"}</td>
                          <td>{item?.SAPCode || "-"}</td>
                          <td>{item?.PartnerCode || "-"}</td>
                          <td>{item?.TotalAccountCommission || "-"}</td>
                          <td>{splitDate(item.InvoiceDate) || "-"}</td>
                          <td>
                            {item.invoiceStatus === "Accept" && (
                              <button
                                className="accept-button"
                                onClick={() => {
                                  getInvoiceId(item.Id);
                                  navigate("/partner-invoice");
                                }}
                              >
                                PARTNER ACCEPTED
                              </button>
                            )}
                            {item.invoiceStatus === "Approved" && (
                              <button
                                className="accept-button "
                                onClick={() => {
                                  getInvoiceId(item.Id);
                                  navigate("/partner-invoice");
                                }}
                              >
                                ADMIN APPROVED
                              </button>
                            )}
                            {item?.invoiceStatus === "Not Accept" && (
                              <button
                                className=" reject-button"
                                onClick={() => {
                                  getInvoiceId(item?.Id);
                                  navigate("/partner-invoice");
                                }}
                              >
                                PARTNER REJECTED
                              </button>
                            )}
                            {item?.invoiceStatus === "Payment Done" && (
                              <button
                                className="accept-button"
                                onClick={() => {
                                  getInvoiceId(item?.Id);
                                  navigate("/partner-invoice");
                                }}
                              >
                                Payment Done
                              </button>
                            )}
                            {item?.invoiceStatus === "" && (
                              <p
                                onClick={() => {
                                  getInvoiceId(item?.Id);
                                  navigate("/partner-invoice");
                                }}
                              >
                                -
                              </p>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  {scrollLoader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <h4 className="report-error-message">No Data Available</h4>
          )}
        </div>
      </main>
      <Modal
        show={showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model partner-modal-rejection invoice"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">Upload Excel File</h2>
          </Modal.Title>
          <button
            onClick={() => setShowModal(false)}
            type="button"
            className="btn-close"
            aria-label="Close"
          >
            <span class="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="upper-text">
            <h5 className="text-inv-pop">
              Sample Commission File
              <div
                onClick={() =>
                  downloadFile(
                    `${partner_Admin_Url}/admin/adminApprovefile?file=1`
                  )}>
                <img src={DownLoadIcon} className="down-icon" />
              </div>
            </h5>
            <h5 className="text-inv-pop">
              Sample Approved List
              <div
                onClick={() =>
                  downloadFile(
                    `${partner_Admin_Url}/admin/adminApprovefile?file=0`
                  )}>
                <img src={DownLoadIcon} className="down-icon" />
              </div>

            </h5>
          </div>
          <div
            className="custom-modal-wrapper-invoice"
            onChange={(e) => getRadioValue(e)}
          >
            <div className="radio-wrapper">
              <input
                type="radio"
                id="Upload Commission"
                name="options"
                value="Upload Commission"
                checked={radioChanges === "Upload Commission"}
              />
              <label for="contactChoice2" className="form-label">
                Upload Commission
              </label>
              <input
                type="radio"
                id="Upload Approved List"
                name="options"
                value="Upload Approved List"
                checked={radioChanges === "Upload Approved List"}
              />
              <label for="contactChoice2" className="form-label">
                Upload Approved List
              </label>
            </div>
          </div>
          <label className="form-label">Upload Commission</label>
          <div className="radio-wrapper">
            <input
              type="file"
              id="uploadFile"
              onChange={(e) => handleFileChange(e)}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          {/* <p className="error-partner">Upload Excel File</p> */}
          <button
            className="rej-btn"
            onClick={() => {
              setShowModal(false);
              submitButtonAPI();
            }}
          >
            Upload File
          </button>

        </Modal.Footer>
      </Modal>

      {customDate && customDate ? (
        <Modal
          show={customDate}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="setting-model partner-modal-rejection"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">Custom Date</h2>
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close">
              <span
                className="icon-close"
                onClick={() => setCustomDate(false)}
              ></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="custom-modal-wrapper row">
              <div className="col-md-6 ">
                <label className="form-label">{Constants.From_Date}</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) => setFromDate(e?.target?.value)}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{Constants.To_Date}</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) => setToDate(e?.target?.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <SubmitButton />
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
}

export default Invoice;
